// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Utils$SF = require("./Utils.bs.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Belt_Result = require("bs-platform/lib/js/belt_Result.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

function eclass_encode(c) {
  switch (c) {
    case /* Job */0 :
        return "job";
    case /* Semaphore */1 :
        return "semaphore";
    case /* Project */2 :
        return "project";
    case /* ProjectTemplate */3 :
        return "project-template";
    case /* Nodeset */4 :
        return "nodeset";
    case /* Secret */5 :
        return "secret";
    
  }
}

function eclass_decode(json) {
  return Belt_Result.flatMap(Decco.stringFromJson(json), (function (str) {
                switch (str) {
                  case "job" :
                      return {
                              TAG: /* Ok */0,
                              _0: /* Job */0
                            };
                  case "nodeset" :
                      return {
                              TAG: /* Ok */0,
                              _0: /* Nodeset */4
                            };
                  case "project" :
                      return {
                              TAG: /* Ok */0,
                              _0: /* Project */2
                            };
                  case "project-template" :
                      return {
                              TAG: /* Ok */0,
                              _0: /* ProjectTemplate */3
                            };
                  case "secret" :
                      return {
                              TAG: /* Ok */0,
                              _0: /* Secret */5
                            };
                  case "semaphore" :
                      return {
                              TAG: /* Ok */0,
                              _0: /* Semaphore */1
                            };
                  default:
                    return Decco.error(undefined, "Invalid Zuul configuration class", json);
                }
              }));
}

function eclasses_encode(eclasses) {
  return Decco.optionToJson((function (param) {
                return Decco.listToJson(eclass_encode, param);
              }), eclasses);
}

function eclasses_decode(jsonObject) {
  return Decco.optionFromJson((function (param) {
                return Decco.listFromJson(eclass_decode, param);
              }), jsonObject);
}

var eclasses_codec = [
  eclasses_encode,
  eclasses_decode
];

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "connection",
                Decco.optionToJson(Decco.stringToJson, v.connection)
              ],
              [
                "zuul/include",
                eclasses_encode(v.zuul_include)
              ],
              [
                "default-branch",
                Decco.optionToJson(Decco.stringToJson, v.default_branch)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var connection = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "connection"), null));
    if (connection.TAG === /* Ok */0) {
      var zuul_include = eclasses_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "zuul/include"), null));
      if (zuul_include.TAG === /* Ok */0) {
        var default_branch = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "default-branch"), null));
        if (default_branch.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    name: name._0,
                    connection: connection._0,
                    zuul_include: zuul_include._0,
                    default_branch: default_branch._0
                  }
                };
        }
        var e = default_branch._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".default-branch" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = zuul_include._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".zuul/include" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = connection._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".connection" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function union_encode(v) {
  if (v.TAG === /* Full */0) {
    return [
            "Full",
            t_encode(v._0)
          ];
  } else {
    return [
            "Name",
            Decco.stringToJson(v._0)
          ];
  }
}

function union_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Full" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Full */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Name" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Name */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function getName(union) {
  if (union.TAG === /* Full */0) {
    return union._0.name;
  } else {
    return union._0;
  }
}

function getConnection(union) {
  if (union.TAG === /* Full */0) {
    return union._0.connection;
  }
  
}

function encode(union) {
  if (union.TAG === /* Full */0) {
    return Belt_Option.getExn(Utils$SF.encodeDictName(t_encode(union._0)));
  } else {
    return union._0;
  }
}

function decode(jsonObject) {
  var s = Decco.stringFromJson(jsonObject);
  if (s.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              TAG: /* Name */1,
              _0: s._0
            }
          };
  }
  var obj = Utils$SF.decodeOneDictName(jsonObject);
  if (obj !== undefined) {
    return Belt_Result.map(t_decode(Caml_option.valFromOption(obj)), (function (v) {
                  return {
                          TAG: /* Full */0,
                          _0: v
                        };
                }));
  } else {
    return Decco.error(undefined, "Unknown source repository", jsonObject);
  }
}

function encodes(unions) {
  return Decco.listToJson(encode, unions);
}

function decodes(jsonObject) {
  return Decco.listFromJson(decode, jsonObject);
}

var codec = [
  encodes,
  decodes
];

exports.eclass_encode = eclass_encode;
exports.eclass_decode = eclass_decode;
exports.eclasses_encode = eclasses_encode;
exports.eclasses_decode = eclasses_decode;
exports.eclasses_codec = eclasses_codec;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.union_encode = union_encode;
exports.union_decode = union_decode;
exports.getName = getName;
exports.getConnection = getConnection;
exports.encode = encode;
exports.decode = decode;
exports.encodes = encodes;
exports.decodes = decodes;
exports.codec = codec;
/* No side effect */
